import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import SVGIcon from "../svg-icon/svg-icon";
import _ from "underscore";
import { gettext } from "web/script/modules/django-i18n";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import style from "./shipping.css";
import LeadLink from "../lead-link/lead-link";

function Shipping({ className, freeShippingUrl, message, isSavedForLater, retailerName, leadUrl }) {
    const seeMoreOnSpanProps = {
        class: style.seeMoreOn
    };
    const seeMoreOnRetailerSpanProps = {
        class: style.link
    };
    // we escape retailerName, and so mark this string as available for dangerouslySetInnerHTML
    const seeMoreOnRetailerSafeHtml = {
        __html: gettext("in_stock_product.see_more_on_retailer.in_spans", {
            see_more_span_props: getHtmlProps(seeMoreOnSpanProps),
            retailer_name_span_props: getHtmlProps(seeMoreOnRetailerSpanProps),
            retailer_name: _.escape(retailerName)
        })
    };
    return (
        <div className={classnames(className, style.wrapper)}>
            <div className={style.message}>
                <div className={style.shippingIcon}>
                    <SVGIcon name="truck" />
                </div>
                {freeShippingUrl ? (
                    <a href={freeShippingUrl} dangerouslySetInnerHTML={{ __html: message }} />
                ) : (
                    <span dangerouslySetInnerHTML={{ __html: message }} />
                )}
            </div>
            <div className={style.linkHolder}>
                <LeadLink reason="retailer-link" href={leadUrl} isSavedForLater={isSavedForLater}>
                    <span dangerouslySetInnerHTML={seeMoreOnRetailerSafeHtml} />
                </LeadLink>
                <SVGIcon name="round-chevron" />
            </div>
        </div>
    );
}

export default Shipping;

Shipping.propTypes = {
    className: PropTypes.string,
    freeShippingUrl: PropTypes.string,
    message: PropTypes.string.isRequired,
    isSavedForLater: PropTypes.bool,
    retailerName: PropTypes.string,
    leadUrl: PropTypes.string
};

Shipping.defaultProps = {
    isSavedForLater: false
};
